module.exports = __webpack_public_path__ + "img/csm__MG_8855_9c2f84fae9_0.f5a44328.jpg";